import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { filter, each, map } from 'lodash';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { getTablePreference } from '../../../App/AppReducer';
import { updateTablePreferenceColumnPositions, updateTablePreferenceColumn } from '../../../App/AppActions';

import DeleteColumnModal from '../../../../components/god-table/delete-column-modal';
import ResetColumnsModal from '../../../../components/god-table/reset-columns-modal';
import EditColumnModal from '../../../../components/god-table/edit-column-modal';
import FeedbackRequestSettingPage from '../DiscoveryBotPage/FeedbackRequestSettingPage';

import {
  requestEditColumn,
  requestDeleteColumn,
  requestResetColumns,
} from '../../../../components/god-table/actions';

import styles from './styles.css';

const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};



class TileSettingForm extends Component {
  constructor() {
    super();
    this.state = {
      dragging: false,
      draggedId: null,
      editingIds: {},
    };
    this.requestEditColumn = this.requestEditColumn.bind(this);
    this.requestDeleteColumn = this.requestDeleteColumn.bind(this);
    this.requestResetColumns = this.requestResetColumns.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.toggleVisible = this.toggleVisible.bind(this);
  }

  
  onDragEnd(result) {
    const { source, destination } = result;
    if (!this.state.dragging && source.index !== destination.index) {
      const destinationList = [...this.props.rows];
      const draggedId = this.props.rows[source.index] ? this.props.rows[source.index]._id : null;
      mutatedReorder(
        destinationList,
        source.index,
        destination.index,
      );
      const positions = map(destinationList, '_id');
      this.setState({ dragging: true, draggedId: null }, () => {
        this.props.dispatch(updateTablePreferenceColumnPositions(this.props.id, positions))
          .then(
            () => {
              this.setState({ dragging: false, draggedId });
            },
            () => {
              this.setState({ dragging: false, draggedId });
            },
          );
      });
    }
  }

  toggleVisible(column) {
    const { _id } = column;
    if (this.state.editingIds[_id]) {
      return;
    }
    this.setState({ editingIds: { ...this.state.editingIds, [_id]: true } }, () => {
      const params = { is_visible: !column.is_visible };
      this.props.dispatch(updateTablePreferenceColumn(this.props.id, _id, params))
        .then(
          () => {
            this.setState({ editingIds: { ...this.state.editingIds, [_id]: false } });
          },
          () => {
            this.setState({ editingIds: { ...this.state.editingIds, [_id]: false } });
          },
        );
    });
  }

  requestEditColumn(column) {
    const { id } = this.props;
    this.props.dispatch(requestEditColumn(id, column));
  }

  requestDeleteColumn(column) {
    const { id } = this.props;
    this.props.dispatch(requestDeleteColumn(id, column));
  }

  requestResetColumns() {
    const { id } = this.props;
    this.props.dispatch(requestResetColumns(id));
  }


  renderTableConfig() {
    const { rows, isAccount } = this.props;
    return (
      <div className="clearfix">
        {!isAccount &&
          <div className="pull-left">
            <FeedbackRequestSettingPage showOpportunityStatus />
          </div>
        }
        <div className="pull-right text-right">
          {rows.length < 16 && 
            <Button
              bsStyle="primary"
              onClick={() => {
                this.requestEditColumn({
                  is_visible: true,
                });
              }}
            >
              <Fa name="plus" /> Add a new Row
            </Button>
          }
          {' '}
          <Button
            bsStyle="danger"
            onClick={this.requestResetColumns}
          >
            <Fa name="refresh" /> Reset all rows
          </Button>
        </div>
      </div>
    );
  }

  renderRow(row, index, hasCustomRows, hasMultipleRows) {
    const { rows } = this.props;
    const { dragging, draggedId, editingIds } = this.state;

    const blinking = draggedId === row._id;
    const isEditing = editingIds[row._id] === true;

    let arrowName = 'arrows-v';
    if (rows.length > 1) {
      if (index === 0) {
        arrowName = 'long-arrow-down';
      } else if (index === rows.length - 1) {
        arrowName = 'long-arrow-up';
      }
    }
    if (dragging) {
      arrowName = 'spinner';
    }
    const hasDescription = row.description && row.description.length > 0;

    const tooltip = hasDescription ? (
      <Tooltip id={`${row._id}_tooltip`}>{row.description}</Tooltip>
    ) : null;

    const visibleTooltip = (
      <Tooltip id={`${row._id}-visible-tooltip`}>{row.is_visible ? 'Visible' : 'Hidden'}</Tooltip>
    );


    let api = null;
    
    if (!row.is_system) {
      const total = (row.search_paths || []).length;
      const paths = [];
      each(row.search_paths || [], (p, i) => {
        paths.push((
          <code key={`path-${i}`}>{p}</code>
        ));
        if (i < total - 1) {
          paths.push((
            <Fa name="chevron-right" key={`path-chervon-${i}`} />
          ));
        }
      });
      api = (
        <span>
          {paths}
        </span>
      );
    }

    let eyeIcon = row.is_visible ? 'eye' : 'eye-slash';
    if (isEditing) {
      eyeIcon = 'spinner';
    }

    let { label } = row;
    if (!row.is_visible) {
      label = (
        <em className="text-muted">{label}</em>
      );
    }


    return (
      <Draggable draggableId={row._id} key={row._id} index={index}>
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`${snapshot.isDragging ? styles.dragging : null}`}
            style={provided.draggableProps.style}
          >
            {hasMultipleRows &&
              <td
                width="40"
                className="text-center"
                {...provided.dragHandleProps}
              >
                <Fa
                  name={arrowName}
                  spin={dragging}
                />
              </td>
            }
            <td width="40" className="text-center">
              {!hasMultipleRows && <span {...provided.dragHandleProps}></span>}
              <a
                href=""
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.toggleVisible(row);
                }}
              >
                <OverlayTrigger placement="top" overlay={visibleTooltip}>
                  <Fa name={eyeIcon} spin={isEditing} className={row.is_visible ? 'text-success' : 'text-muted'} />
                </OverlayTrigger>
              </a>
            </td>
            <td>
              <div className={blinking ? 'animated flash' : ''}>
                {row.is_system && label}
                {!row.is_system &&
                  <a
                    href=""
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.requestEditColumn(row);
                    }}
                  >
                    {label}
                  </a>
                }
                {hasDescription && ' '}
                {hasDescription &&
                  <OverlayTrigger placement="right" overlay={tooltip}>
                    <Fa name="info-circle" className="text-active" />
                  </OverlayTrigger>
                }
              </div>
            </td>
            {hasCustomRows &&
              <td>
                {!row.is_system &&
                  <nobr>
                    {api}    
                  </nobr>
                }
              </td>
            }
            {hasCustomRows &&
              <td width="40" className="text-center">
                {!row.is_system &&
                  <a
                    href=""
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.requestDeleteColumn(row);
                    }}
                    className="text-danger"
                  >
                    <Fa name="trash" />
                  </a>
                }
              </td>
            }
          </tr>
        )}
      </Draggable>
    );
  }

  renderRows() {
    const { rows } = this.props;
    const hasCustomRows = filter(rows, { is_system: false }).length > 0;
    const hasMultipleRows = rows.length > 1;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Fragment>
          <table className={`table table-bordered table-condensed table-striped ${styles.table}`}>
            <thead>
              <tr>
                {hasMultipleRows && <th width="40" className="text-center"><Fa className="invisible" name="arrows-v" /></th>}
                <th colSpan="2">Row</th>
                {hasCustomRows && <th>API</th>}
                {hasCustomRows && <th width="40">&nbsp;</th>}
              </tr>
            </thead>
            <Droppable droppableId="drop">
              {(provided, snapshot) => (
                <tbody
                  ref={provided.innerRef}
                  className={snapshot.isDraggingOver ? styles.DraggingOver : null}
                >
                  {rows.map((row, index) => this.renderRow(row, index, hasCustomRows, hasMultipleRows))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </Fragment>
      </DragDropContext>
    );
  }


  render() {
    const { id, isAccount } = this.props;
    return (
      <div>
        {this.renderTableConfig()}
        {isAccount && <p />}
        <DeleteColumnModal isRow />
        <ResetColumnsModal isRow />
        <EditColumnModal validObjects={isAccount ? ['Account'] : ['Opportunity']} isRow id={id} />
        {this.renderRows()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    rows: getTablePreference(state, ownProps.id),
  };
}

TileSettingForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line
  isAccount: PropTypes.bool,
};

TileSettingForm.defaultProps = {
  tableState: {},
  isAccount: false,
};

export default connect(mapStateToProps)(TileSettingForm);
